/**
 * El empleado de un negocio suspendido ve la app en **modo lectura** (laudo de
 * trd-octopus#333, trd-client#269): consulta lo que sus módulos y su grant le
 * dejan, no escribe, y lo mandamos a hablar con el administrador. El dueño no:
 * a él lo frena `BillingAccessBoundary` con el camino al pago.
 *
 * Lo decide el claim `suspended` del token, que es del negocio y viaja igual
 * para todos los roles. Cuando la sesión se renueva con `suspended: false`
 * (trd-client#333), el store cambia y el modo lectura se apaga solo.
 */
export function enModoLectura(
  usuario: { type?: string | null; suspended?: boolean | null } | null
): boolean {
  return !!usuario && usuario.type !== "owner" && usuario.suspended === true;
}

/** La banda de arriba de todas las pantallas. */
export const AVISO_DE_MODO_LECTURA =
  "Tu negocio tiene un pago pendiente: podés consultar, pero no hacer cambios. Hablá con el administrador.";
